import { marker } from '@jsverse/transloco-keys-manager/marker';
import { TranslocoService } from '@jsverse/transloco';

export const PWA_UPDATE_AVAILABLE_KEY = marker('pwa-update.available');
export const PWA_UPDATE_RELOAD_KEY = marker('pwa-update.reload');
export const PWA_UPDATE_LOAD_FAILED_KEY = marker('pwa-update.load-failed');

export interface ToastLike {
  present(): Promise<void>;
}

export interface ToastButtonLike {
  text: string;
  handler?: () => void;
}

export interface ToastControllerLike {
  create(options: {
    message: string;
    duration: number;
    position: 'top' | 'bottom' | 'middle';
    buttons?: ToastButtonLike[];
  }): Promise<ToastLike>;
}

export function updateAvailableToastOptions(
  message: string,
  reloadText: string,
  onReload: () => void,
): {
  message: string;
  duration: number;
  position: 'top';
  buttons: ToastButtonLike[];
} {
  return {
    message,
    duration: 0,
    position: 'top',
    buttons: [
      {
        text: reloadText,
        handler: onReload,
      },
    ],
  };
}

export function loadFailedToastOptions(message: string): {
  message: string;
  duration: number;
  position: 'top';
} {
  return {
    message,
    duration: 0,
    position: 'top',
  };
}

export async function presentUpdateAvailableToast(
  transloco: Pick<TranslocoService, 'translate'>,
  toastController: ToastControllerLike,
  onReload: () => void,
): Promise<void> {
  const toast = await toastController.create(
    updateAvailableToastOptions(
      transloco.translate(PWA_UPDATE_AVAILABLE_KEY),
      transloco.translate(PWA_UPDATE_RELOAD_KEY),
      onReload,
    ),
  );
  await toast.present();
}

export async function presentLoadFailedToast(
  transloco: Pick<TranslocoService, 'translate'>,
  toastController: ToastControllerLike,
): Promise<void> {
  const toast = await toastController.create(
    loadFailedToastOptions(transloco.translate(PWA_UPDATE_LOAD_FAILED_KEY)),
  );
  await toast.present();
}
